import { Button, Space } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

const TOTAL_STEPS = 3;

interface BannerStepFooterProps {
  currentStep: number;
  onSaveDraft: () => Promise<void>;
  onNext: () => Promise<void>;
  isLoading?: boolean;
  isPrimaryActionDisabled?: boolean;
}

export const BannerStepFooter: FC<BannerStepFooterProps> = ({
  currentStep,
  onSaveDraft,
  onNext,
  isLoading = false,
  isPrimaryActionDisabled = false,
}) => {
  const isLastStep = currentStep === TOTAL_STEPS - 1;

  return (
    <FooterWrapper>
      <Space>
        <Button 
          loading={isLoading} 
          onClick={onSaveDraft}
          disabled={isLoading}
        >
          Guardar Rascunho
        </Button>

        <Button
          type='primary'
          loading={isLoading}
          disabled={isPrimaryActionDisabled || isLoading}
          onClick={onNext}
        >
          {isLastStep ? 'Salvar e Publicar' : 'Próximo'}
        </Button>
      </Space>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 48px;
  right: 0;
  padding: 16px 0;
  background: #141414;
  border-top: 1px solid #383838;
  display: flex;
  justify-content: flex-end;
  padding-right: 48px;
`;
